import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TuOrden from "../TuOrden";
import CheckoutBilling from "./CheckoutBilling";
import ShippingAddresses from "./ShippingAddresses";

import { regex_num } from "../../../../constants/regex";
import { CHECKOUT_DISABLED_INPUT, RESIDENCE_TYPE } from "../../../../constants/constants";

import {
    // saveClientEmail
    getPostalcodeData
} from "../../../../actions/checkout";
import { fillOrderData } from "../../../../actions/shop";
import { addressesesList } from "../../../../actions/user-account";
import { normalizeEmail } from '../../../../helpers/security';

//CSS
import './personalcheckout.css';

import {
    Box, Grid, Typography, Select, Avatar, MenuItem, TextField, InputLabel,
    FormControl, InputAdornment
} from "@mui/material";
import DomainIcon from '@mui/icons-material/Domain';
import SignpostIcon from '@mui/icons-material/Signpost';
import ApartmentIcon from '@mui/icons-material/Apartment';
import OtherHousesIcon from '@mui/icons-material/OtherHouses';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import MarkunreadMailboxIcon from '@mui/icons-material/MarkunreadMailbox';
import AlertOrderNoCompleted from "../AlertOrderNoCompleted/AlertOrderNoCompleted";

const PersonalInfoCheckoutComponent = ({
    page, setPage,
    shippingValues, setShippingValues,
    billingValues, setBillingValues,
    paymentValues, setPaymentValues
}) => {
    // información de envío
    const {
        name, lastname, email, tel, street, ext_num,
        int_num, crossing_streets, postalcode, colony,
        city, state, references, residence_type,
        residence_type_select
    } = shippingValues;

    const dispatch = useDispatch();
    const lockedEmail = useSelector(state => state.shop.cart.coupon?.locked_email || '');
    useEffect(() => {
        if (lockedEmail && email !== lockedEmail) setShippingValues(current => ({ ...current, email: lockedEmail }));
    }, [lockedEmail, email, setShippingValues]);

    // régimen fiscal y CFDI disponible
    const { taxSystemData, CFDIData } = useSelector(state => state.checkout);
    // completar información de pedido abandonado?
    const { cart: { checkout: { fill } } } = useSelector(state => state.shop);
    // correo de usuario iniciado
    const { loggedUser: { email: user_email } } = useSelector(state => state.user);

    // información recuperada con el código postal
    // colonias disponibles para campo de envío
    const [colonies, setColonies] = useState([]);

    // campo de código postal manipulado
    const [touched, setTouched] = useState(false);

    // deshabilitación de campos
    const [disabledFields, setDisabledFields] = useState(CHECKOUT_DISABLED_INPUT);
    const { cityInput, stateInput } = disabledFields;

    // direcciones de envío del usuario
    const [shippingAddresses, setShippingAddresses] = useState([]);
    // direcciones de facturación del usuario
    const [billingAddresses, setBillingAddresses] = useState([]);

    // régimen fiscal filtrado
    const [taxSystem, setTaxSystem] = useState([]);
    // CFDI filtrado
    const [CFDI, setCFDI] = useState([]);

    // abrir / cerrar modal
    const [open, setOpen] = useState(false);

    useEffect(() => {
        getMyAdresses();
        dispatch(fillOrderData(false));
    }, []);

    useEffect(() => {
        if (touched && postalcode.length === 5)
            postalcodeData();
    }, [touched, postalcode]);

    // obtiene direcciones de envío/facturación del usuario
    const getMyAdresses = async () => {
        await addressesesList(
            user_email, fill, postalcode ? true : false,
            setShippingValues, setBillingValues,
            setShippingAddresses, setBillingAddresses,
            taxSystemData, CFDIData,
            setTaxSystem, setCFDI
        );
    };

    // cambios en datos de envío
    const handleInputChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        // propiedades con únicamente números
        if ((['ext_num', 'tel', 'postalcode'].includes(name))) {
            if (value === '' || regex_num.test(value))
                setShippingValues({ ...shippingValues, [name]: value });
            if (name === 'postalcode')
                inputTouched();
        } else
            setShippingValues({ ...shippingValues, [name]: value });
    };

    const postalcodeData = async () => {
        const resp = await getPostalcodeData(postalcode);
        if (resp.status) {
            const { resp: { municipio, estado, asentamiento } } = resp;
            setShippingValues(e => ({
                ...e,
                colony: '',
                city: municipio,
                state: estado
            }));
            setColonies(asentamiento);
            // deshabilita campos
            setDisabledFields({
                ...disabledFields,
                cityInput: true, stateInput: true
            });
        } else {
            // limpia colonias disponibles
            setColonies([]);
            // habilita campos
            setDisabledFields({
                ...disabledFields,
                cityInput: false, stateInput: false
            });
        }
    };

    // campo pierde foco
    // const handleInputBlur = async ({ target }) => {
    //     if (target.name === 'email') {
    //         setTimeout(async () => {
    //             await saveClientEmail(email);
    //         }, 1000);
    //     }
    // };

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    // seleccionar dirección de envío
    const selectAddress = address_id => () => {
        handleClose();
        const filtered = shippingAddresses.find(e => e._id === address_id);
        if (filtered)
            setShippingValues({
                ...shippingValues,
                ...filtered
            });
    };

    // campo de código postal manipulado
    const inputTouched = () => {
        if (!touched) setTouched(true);
    };

    return (
        <>
            {/* Alerta de pedido no completado */}
            <Box sx={{ mt: 3 }}>
                <AlertOrderNoCompleted />
            </Box>

            <Box sx={{ mt: 3 }}>
                <Grid container spacing={4}>
                    <Grid item xl={7} lg={7} md={12} sm={12} xs={12}>
                        {/* Datos de envío */}
                        <Box sx={{ p: 3 }} className="personal-info-form">
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 5 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2 }}>
                                    <Box>
                                        <Avatar sx={{ bgcolor: '#2699FB', fontFamily: 'sans-serif' }}>1</Avatar>
                                    </Box>
                                    <Typography variant='h6' sx={{ fontWeight: '600', mt: .5 }} align='center'>Datos de envío</Typography>
                                </Box>
                                <ShippingAddresses
                                    shippingAddresses={shippingAddresses}
                                    open={open}
                                    handleOpen={handleOpen}
                                    handleClose={handleClose}
                                    selectAddress={selectAddress}
                                />
                            </Box>
                            <Grid container spacing={3.5}>
                                {/* Nombres */}
                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Nombre (s)"
                                            inputProps={{ maxLength: 60 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <i className="fa-solid fa-user"></i>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            name="name"
                                            value={name}
                                            onChange={handleInputChange}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Apellidos */}
                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Apellidos"
                                            inputProps={{ maxLength: 60 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <i className="fa-solid fa-user-group"></i>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            name="lastname"
                                            value={lastname}
                                            onChange={handleInputChange}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Correo electronico */}
                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Correo electrónico"
                                            inputProps={{ maxLength: 120 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <i className="fa-solid fa-envelope"></i>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            name="email"
                                            disabled={Boolean(lockedEmail)}
                                            helperText={lockedEmail ? 'Correo vinculado a tu cupón. Retira el cupón para utilizar otro.' : ''}
                                            value={email}
                                            onChange={handleInputChange}
                                            onBlur={() => setShippingValues(current => ({
                                                ...current, email: normalizeEmail(current.email)
                                            }))}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Número de telefono */}
                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Número telefónico"
                                            inputProps={{ maxLength: 10 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <i className="fa-solid fa-phone"></i>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            name="tel"
                                            value={tel}
                                            onChange={handleInputChange}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Calle */}
                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Calle"
                                            inputProps={{ maxLength: 60 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <i className="fa-solid fa-house"></i>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            name="street"
                                            value={street}
                                            onChange={handleInputChange}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Número exterior*/}
                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Número exterior"
                                            inputProps={{ maxLength: 4 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <i className="fa-solid fa-hashtag"></i>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            name="ext_num"
                                            value={ext_num}
                                            onChange={handleInputChange}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Número interior"
                                            inputProps={{ maxLength: 8 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <i className="fa-solid fa-hashtag"></i>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            name="int_num"
                                            value={int_num}
                                            onChange={handleInputChange}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Cruce de calles */}
                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Entre las calles"
                                            inputProps={{ maxLength: 200 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <i className="fa-solid fa-road"></i>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            name="crossing_streets"
                                            value={crossing_streets}
                                            onChange={handleInputChange}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Código postal */}
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Código postal"
                                            inputProps={{ maxLength: 5 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <MarkunreadMailboxIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            name="postalcode"
                                            value={postalcode}
                                            onChange={handleInputChange}
                                            onFocus={inputTouched}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Colonia */}
                                {
                                    colonies.length <= 0 ?
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id=""
                                                    label="Colonia"
                                                    inputProps={{ maxLength: 100 }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <LocationCityIcon />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                    variant="standard"
                                                    name="colony"
                                                    value={colony}
                                                    onChange={handleInputChange}
                                                />
                                            </FormControl>
                                        </Grid>
                                        :
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <InputLabel>Colonia</InputLabel>
                                                <Select
                                                    id=""
                                                    name="colony"
                                                    value={colony}
                                                    label="Colonia"
                                                    onChange={handleInputChange}
                                                    variant="standard"
                                                >
                                                    {
                                                        colonies.map(({ nombre }) =>
                                                            <MenuItem key={nombre}
                                                                value={nombre}>{nombre}
                                                            </MenuItem>
                                                        )
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                }

                                {/* Municipio */}
                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Municipio"
                                            inputProps={{ maxLength: 100 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <DomainIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            disabled={cityInput}
                                            name="city"
                                            value={city}
                                            onChange={handleInputChange}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Estado */}
                                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Estado"
                                            inputProps={{ maxLength: 100 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <ApartmentIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            disabled={stateInput}
                                            name="state"
                                            value={state}
                                            onChange={handleInputChange}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Referencias de domicilio */}
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id=""
                                            label="Referencias del domicilio"
                                            inputProps={{ maxLength: 200 }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SignpostIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            variant="standard"
                                            name="references"
                                            value={references}
                                            onChange={handleInputChange}
                                        />
                                    </FormControl>
                                </Grid>

                                {/* Tipo de domicilio */}
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <InputLabel>Tipo de domicilio</InputLabel>
                                        <Select
                                            name="residence_type_select"
                                            value={residence_type_select}
                                            label="Tipo de domicilio"
                                            onChange={handleInputChange}
                                            variant="standard">
                                            {
                                                RESIDENCE_TYPE.map(e =>
                                                    <MenuItem key={e}
                                                        value={e}>{e}
                                                    </MenuItem>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {
                                    residence_type_select === 'Otro' &&
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <TextField
                                                label="Escriba tipo de domicilio"
                                                inputProps={{ maxLength: 60 }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <OtherHousesIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                variant="standard"
                                                name="residence_type"
                                                value={residence_type}
                                                onChange={handleInputChange}
                                            />
                                        </FormControl>
                                    </Grid>
                                }
                            </Grid>
                        </Box>
                        {/* Fin Datos de envío */}

                        {/* Datos de facturación */}
                        <CheckoutBilling
                            billingValues={billingValues}
                            setBillingValues={setBillingValues}
                            billingAddresses={billingAddresses}
                            disabledFields={disabledFields}
                            setDisabledFields={setDisabledFields}
                            taxSystem={taxSystem}
                            setTaxSystem={setTaxSystem}
                            CFDI={CFDI}
                            setCFDI={setCFDI}
                        />
                    </Grid>

                    <TuOrden
                        page={page}
                        setPage={setPage}
                        fill={fill}
                        billingValues={billingValues}
                        shippingValues={shippingValues}
                        paymentValues={paymentValues}
                        setPaymentValues={setPaymentValues}
                    />
                </Grid>
            </Box>
        </>
    );
};

export default PersonalInfoCheckoutComponent;
